import { render } from "./ReportView.vue?vue&type=template&id=7649bb5f&scoped=true"
import script from "./ReportView.vue?vue&type=script&lang=js"
export * from "./ReportView.vue?vue&type=script&lang=js"

import "./ReportView.vue?vue&type=style&index=0&id=7649bb5f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7649bb5f"],['__file',"src/views/ProductDiagnosis/components/ReportView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7649bb5f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7649bb5f', __exports__)) {
    api.reload('7649bb5f', __exports__)
  }
  
  module.hot.accept("./ReportView.vue?vue&type=template&id=7649bb5f&scoped=true", () => {
    api.rerender('7649bb5f', render)
  })

}


export default __exports__